import React from 'react'

import { Wrapper, Inner, Line } from './styles.js'

class ButtonMenu extends React.Component {
    
    render() {
        return (
            <Wrapper theme={this.props.theme} onClick={this.props.onClick} active={this.props.active}>
                <Inner>
                    <Line />
                    <Line />
                    <Line />
                </Inner>
            </Wrapper>
        )
    }

}

export default ButtonMenu